import carsTypes from "./cars.types";
import {AttachLabel} from "./cars.utils";

export const GetCarsData = res =>({
    type: carsTypes.GET_CARS_DATA,
    payload: AttachLabel(res.data.data),
});

export const SelectedCar = Data =>({
    type: carsTypes.CAR_SELECTED,
    payload: Data
});
export const SetSelectedSingleCar = (car) =>({
    type: carsTypes.GET_SINGLE_CAR_DATA,
    payload: car
});

export const RemoveSelectedCar = () =>({
    type: carsTypes.REMOVE_CAR_SELECTED_INFO,
});
export const RemoveCarsData = () =>({
    type: carsTypes.REMOVE_CARS_DATA,
});
export const GetReports = (reports) =>({
    type: carsTypes.GET_REPORTS,
    payload: reports
});
export const ChangeDay = (day) =>({
    type: carsTypes.CHANGE_DAY,
    payload: day
});
export const SetIcons = (icons) =>({
    type: carsTypes.SET_ICONS,
    payload: icons
});

export const SetInterval = (interval) =>({
    type: carsTypes.SET_INTERVAL,
    payload: interval
});
export const SetReportIndex = (index) =>({
    type: carsTypes.SET_REPORT_INDEX,
    payload: index
});
export const SetReportSpeed = (speed) =>({
    type: carsTypes.SET_REPORT_SPEED,
    payload: speed
});
export const SetArrowIcon = (Icon) =>({
    type: carsTypes.SET_ARROW_ICON,
    payload: Icon
});
export const SetStartRepTime = (Stime) =>({
    type: carsTypes.SET_START_REP_TIME,
    payload: Stime
});
export const SetEndtRepTime = (Etime) =>({
    type: carsTypes.SET_END_REP_TIME,
    payload: Etime
});
export const AddCarToHoldOverCars = (car) =>({
    type: carsTypes.ADD_HOLDOVER_CAR,
    payload: car
});
export const RemoveCarFromHoldOverCars = (car) =>({
    type: carsTypes.REMOVE_HOLDOVER_CAR,
    payload: car
});
export const SetHoldOverCars = (array) =>({
    type: carsTypes.SET_HOLDOVER_CARS,
    payload: array
});
export const SetAllDeviceInfo = deviceInfo =>({
    type: carsTypes.SET_ALL_DEVICE_INFO,
    payload: deviceInfo
});
export const SetIsWithOutPoint = deviceInfo =>({
    type: carsTypes.SET_IS_WITH_OUT_POINT,
    payload: deviceInfo
});